export const Roles = {
  DEV: 1,
  ADMIN: 2,
  USER: 3,
};

export const images = {
  SUMMARY: "summary.png",
  INFO: "info.png",
  IMAGE: "image.png",
};

//Pagination
export const PAGE_SIZE_CHANNELS = 10;
export const PAGE_SIZE_POSTS = 5;
export const PAGE_SIZE_PHONES = 10;

//Menu
export const MENU_DAYS = 15;
export const MENU_MAX_ITEMS = 6;

export const menuOptions = [
  { value: false, label: "Menú Comida" },
  { value: true, label: "Menú Cena" },
];

//Audiences
export const channelTypeOptions = [
  { value: 1, label: "Mediaset" },
  { value: 2, label: "Principales" },
  { value: 3, label: "Otros canales" },
];

export const dayTimeOptions = [
  { value: 1, label: "Total día", name: "totalDay" },
  { value: 2, label: "Day time", name: "dayTime" },
  { value: 3, label: "Prime time", name: "primeTime" },
];

export const slider_subcategories_settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 8,
  slidesToScroll: 8,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 3,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

//Post
export const POST_TYPE = {
  Link: 1,
  Document: 2,
  Post: 3,
  Sections: 4,
};

export const FIELD_TYPES = {
  String: "String",
  Select: "Select",
  Number: "Number",
};

//Fields
export const FieldTypesOptions = [
  { label: "String", value: "String" },
  { label: "Select", value: "Select" },
  { label: "Number", value: "Number" },
];

//Complaints
export const COMPLAINT_STATE = {
  Pending: 1,
  InProgress: 2,
  Closed: 3,
  Removed: 4,
};

export const ComplaintStatesOptions = [
  { label: "Pendiente", value: 1 },
  { label: "En trámite", value: 2 },
  { label: "Cerrada", value: 3 },
  { label: "Descartada", value: 4 },
];
